import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import moment from "moment";

const PackedDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { barcode } = useParams();
  const items = location.state?.filteredItems || [];

  const mainItem = items[0] || {}; // Use first item for top summary

  return (
    <div className="mx-10 my-6 p-8 rounded-3xl border border-gray-200 shadow-lg bg-white">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-secondary">Packed Product Details</h1>
          <p className="text-gray-500">View all products packed under the same barcode</p>
        </div>
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-md"
        >
          <ArrowLeft size={18} />
          Back
        </button>
      </div>

      {/* Summary Info */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
          <p className="text-gray-500 text-sm">Customer</p>
          <h3 className="font-semibold text-lg">
            {mainItem.customer_company_name || "N/A"}
          </h3>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
          <p className="text-gray-500 text-sm">Order Reference No.</p>
          <h3 className="font-medium">{mainItem.order_reference_no || "N/A"}</h3>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
          <p className="text-gray-500 text-sm">Box Barcode</p>
          <h3 className="font-medium">{mainItem.barcode || "N/A"}</h3>
        </div>
      </div>

      {/* Table Title */}
      <h2 className="text-lg font-semibold mb-3">Packed Items</h2>

      {/* Items Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 text-sm">
          <thead className="bg-gray-100 text-gray-700 uppercase text-xs">
            <tr>
              <th className="p-3 text-left">#</th>
              <th className="p-3 text-left">Quantity Packed</th>
              <th className="p-3 text-left">Maker</th>
              <th className="p-3 text-left">Part Number</th>
              <th className="p-3 text-left">HS Code</th>
            </tr>
          </thead>
          
          <tbody>
            {Array.isArray(items) && items.length > 0 ? (
              items.map((item, index) => (
                <tr
                  key={index}
                  className="border-t hover:bg-gray-50 transition-colors"
                >
                  <td className="p-3 text-gray-500">{index + 1}</td>
                  <td className="p-3 font-medium text-gray-800">{item.quantity}</td>
                  <td className="p-3">{item.order_brand || "-"}</td>
                  <td className="p-3">{item.part_number}</td>
                  <td className="p-3">{item.hs_code || "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center p-6 text-gray-500">
                  No packed items found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PackedDetails;
